import { MealPreferencesDialogState, MealPreferencesDialogView } from './types';

/** Some views are displayed in a sequence. This function gets the next view */
export const getNextView = (
  state: MealPreferencesDialogState
): MealPreferencesDialogView => {
  switch (state.view) {
    case 'eats_meat':
      /** If they have just specified that they eat meat, take them to the meat types. Otherwise, return to main */
      return state.draft_preferences.eats_meat ? 'meat_types' : 'main';
    case 'meat_types':
      return 'diet_balance';
    default:
      return 'main';
  }
};
